module.exports = __webpack_public_path__ + "Roboto-Medium.303ded6436dcf7ea7515.woff";


//////////////////
// WEBPACK FOOTER
// /Desenvolvimento/PMP/painel/~/roboto-fontface/fonts/Roboto/Roboto-Medium.woff
// module id = ../../../../roboto-fontface/fonts/Roboto/Roboto-Medium.woff
// module chunks = 34